import React, { Component } from 'react';
import { Row, Col, Table, Modal, FormLabel, FormControl } from 'react-bootstrap';
import { request } from '../../constants/constants';

class SecDoctorList extends Component {
    constructor(props){
        super(props);
        this.state = {
            names: [],
            showAppointmentModal: false,
            showDeleteModal: false,
            secretaries: [],
            doctors: []
        }
    }

    componentDidMount(){
        request('GET', '/user_doctor/', {}, true).then(result => { 
            // console.log(result);
            const names = result.data.data.map(obj => ({
                id: obj.id,
                doctor: obj.doctor,
                secretary: obj.secretary
            }));

            let datas = names.sort((a, b) => (a.secretary.first_name + ' ' + a.secretary.last_name > b.secretary.first_name + ' ' + a.secretary.last_name) ? 1 : -1)
        
            this.setState({
                names: names              
            }); 

            
        }).catch(err => { 
            this.setState({
                isLoading: false,
                error: err.response
            })
        })

        request('GET', '/users/secretaries', {}, true).then(result => {
            const secretaries = result.data.data.map(obj => ({
              id: obj.id,
              name: obj.title + '. ' + obj.first_name + ' ' + obj.last_name
            }));
            this.setState({ secretaries });
        }).catch(err => { 
            this.setState({
                isLoading: false,
                error: err.response
            })
        });
  
        request('GET', '/doctors/allDoctorsByAdminOnlyActive', {}, true).then(result => {
            // console.log(result);
            const doctors = result.data.data.map(obj => ({
                id: obj.ID,
                name: obj.title + '. ' + obj.first_name + ' ' + obj.last_name
            }));
            this.setState({ doctors });
        }).catch(err => { 
            this.setState({
                isLoading: false,
                error: err.response
            })
        });
    }

    handleSecretary = e => {
        this.setState({
            user_id: e.target.value
        })
    }
      
    handleDoctor = e => {
        this.setState({
            doctor_id: e.target.value
        })
    }

    handleDelete = e => {
        this.setState({ showDeleteModal: true, currentId: e.target.value})
    }

    handleRemove = e => {
        console.log(e.target.value);
        const data = {
             id: e.target.value
        }
        request('DELETE', `/user_doctor/${e.target.value}`, data, true).then(result => { 
            this.setState({
                isLoading: false,
            })    
            window.location.href = "/secdoctorlist";
        }).catch(err => {
            console.error(err.response);
            this.setState({
                isLoading: false,
                error: err.response.data.message,
                responseCode: err.response.status
            })
        })
    }
  
    handleAppointSec = e => {
        const data = {
            user_id: this.state.user_id,
          doctor_id: this.state.doctor_id
        }
        request('POST', '/user_doctor/addRelationship', data, true).then(result => { 
            this.setState({
                isLoading: false,
                showAppointmentModal: false,
                showSuccessModal: true
            })         
        }).catch(err => {
            console.error(err.response);
            this.setState({
                isLoading: false,
                error: err.response.data.message,
                responseCode: err.response.status
            })
        })
    }

    /* Modal Functions*/
    handleAppointmentModal = (e) => {
        this.setState({ 
          showAppointmentModal: true 
        })
    }
  
    hideAppointmentModal = () => {
        this.setState({ 
            showAppointmentModal: false 
        })
    }
  
    hideSuccessModal = () => {
        this.setState({ 
            showSuccessModal: false 
        })
        window.location.href = "/secdoctorlist";   
    }

    hideDeleteModal = () => {
        this.setState({ 
            showDeleteModal: false 
        })
    }

    render() {
        let current_name = null;

        return (
            <div className="container-fluid">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <Row>
                            <Col><h5 className="m-0 font-weight-bold text-primary center">Secretaries - Doctors List</h5></Col>
                            <Col sm={2} style={{textAlign: "right"}}>
                                <button type="submit" className="btn btn-primary center" onClick={this.handleAppointmentModal}><i class="far fa-calendar-check"></i> Appoint Secretary</button>
                            </Col>
                        </Row>
                    </div>
                    <div className="card-body">
                        {/* Modal for Delete  */}
                        <Modal show={this.state.showDeleteModal} backdrop="static">
                            <Modal.Header onClick={this.hideDeleteModal} closeButton>
                                <Modal.Title><h5 className="m-0 font-weight-bold text-danger">Confirmation: </h5></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p style={{textAlign: "center"}}>Are you sure you want to delete this?</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-secondary center" onClick={this.hideDeleteModal}>
                                    Cancel
                                </button>
                                <button 
                                    className="btn btn-danger center" 
                                    value={this.state.currentId} 
                                    onClick={this.handleRemove}
                                >Delete
                                </button>
                            </Modal.Footer>
                        </Modal>

                        {/* Modal for appointment of Secretary */}
                        <Modal show={this.state.showAppointmentModal}>
                        <Modal.Header onClick={this.hideAppointmentModal} closeButton>
                            <Modal.Title><h5 className="m-0 font-weight-bold text-danger">Secretary Appointment</h5></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className='center m-2'>
                                <Col sm={2}><FormLabel>Secretary: </FormLabel></Col>
                                <Col sm={5}>
                                    <FormControl
                                        as = "select"
                                        type="text"
                                        name="secretary"
                                        className="center"
                                        onChange={this.handleSecretary}
                                    >
                                    <option value="-Select-">-Select-</option>
                                    {this.state.secretaries.map(secretary => (
                                        <option value={secretary.id}>{secretary.name}</option>
                                    ))}
                                    </FormControl>
                                </Col>
                            </Row>
                            <Row className='center m-2'>
                                <Col sm={2}><FormLabel>Doctor: </FormLabel></Col>
                                <Col sm={5}>
                                    <FormControl
                                    as = "select"
                                    type="text"
                                    name="doctor"
                                    className="center"
                                    onChange={this.handleDoctor}
                                    >
                                    <option value="-Select-">-Select-</option>
                                    {this.state.doctors.map(doctor => (
                                        <option value={doctor.id}>{doctor.name}</option>
                                    ))}
                                    </FormControl>
                                </Col>
                            </Row>
                            <Row className='center m-2'>
                                <p style={{color: '#FF0000', display: this.state.responseCode === 403 || 422 ? 'block' : 'none' }}>{this.state.error}</p>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary center" onClick={this.hideAppointmentModal}>
                                Cancel
                            </button>
                            <button className="btn btn-primary center" onClick={this.handleAppointSec}>
                                Appoint
                            </button>
                        </Modal.Footer>
                        </Modal>

                        {/* Modal for Successfully Appointed */}
                        <Modal show={this.state.showSuccessModal}>
                            <Modal.Header onClick={this.hideSuccessModal} closeButton>
                                <Modal.Title><h5 className="m-0 font-weight-bold text-danger">Confirmation: </h5></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Successfully Appointed!</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-primary center" onClick={this.hideSuccessModal}>
                                    OK
                                </button>
                            </Modal.Footer>
                        </Modal>
                        <Table striped bordered hover size="sm" className="center">
                            <thead>
                                <tr>
                                    <th>Actions</th>
                                    <th>Secretaries</th>
                                    <th>Doctors</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {this.state.names.map((name, i) => { 
                                    if(name.secretary){
                                        if(name.secretary.status){
                                            if (current_name === null) {
                                                //1st attempt
                                                current_name = name.secretary.first_name + ' ' + name.secretary.last_name
                                            } else {
                                                //after the 1st attemp all process will be here
                                                if (current_name === name.secretary.first_name + ' ' + name.secretary.last_name) {
                                                    return <tr>
                                                                <td><button className="btn btn-danger center" value={name.id} onClick={this.handleDelete}>Remove</button></td>
                                                                <td></td>  
                                                                <td style={{ color: name.doctor ? (	name.doctor.status ? 'black' : 'grey') : '' }}>{ (name.doctor ? name.doctor.first_name : '') + ' ' + (name.doctor ? name.doctor.last_name : '-')}</td>
                                                            </tr>
                                                } else {
                                                    current_name = name.secretary.first_name + ' ' + name.secretary.last_name;
                                                }
                                            }
                                            return <tr>
                                                        <td><button className="btn btn-danger center" value={name.id} onClick={this.handleDelete}>Remove</button></td>
                                                        <td>{current_name}</td>
                                                        <td style={{ color: name.doctor ? (	name.doctor.status ? 'black' : 'grey') : '' }}>{ (name.doctor ? name.doctor.first_name : '') + ' ' + (name.doctor ? name.doctor.last_name : '-')}</td>
                                                    </tr>
                                        }
                                    }  
                                 })}
                                 
                            </tbody>                           
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

export default SecDoctorList;